import React from 'react';
import './ProductOnboardingFlow.css';

const ProductOnboardingFlow = () => (
  <section className="onboarding-flow-section">
    <div className="onboarding-flow-container">
      <div className="onboarding-flow-left">
        <h2 className="onboarding-flow-title">Effortless Onboarding for Sponsored Employees</h2>
        <p className="onboarding-flow-desc">
          Easily manage the entire process for sponsored healthcare workers in just
          <a href="#" className="onboarding-flow-link"> 4 simple steps</a>. From collecting details to document verification, our smart flow ensures full compliance without the stress. Let Genix handle the complexities for you.
        </p>
      </div>
      <div className="onboarding-flow-right">
        <img src="/images/BoardProduct.png" alt="Onboarding Flow" className="onboarding-flow-img" />
      </div>
    </div>
  </section>
);

export default ProductOnboardingFlow; 